<script>
	import { Link } from "svelte-routing";

	export let email = "";
	export let firstName = "";
	export let lastName = "";
	export let subscriptionStatus = "";
	export let organizationNumber = "";
	export let organizationNumberInput = "";
	export let organizationNumberError = "";
	export let actionLoading = false;
	export let isSyncOnCooldown = false;
	export let isPremium = false;

	export let onEditOrgNumber = () => {};
	export let onUpdateOrgNumber = () => {};
	export let onCancelOrgEdit = () => {};
	export let onValidateInput = () => {};
	export let onFormatBlur = () => {};
	export let onSyncSubscription = () => {};
</script>

<div class="content-box profile-details-box">
	<h4 class="section-title">
		{#if !isPremium}Konto{:else}Personlig information{/if}
	</h4>

	<div class="profile-info-list">
		<div class="info-item">
			<span class="info-label">Medlemsstatus</span>
			<span
				class="info-value membership-status"
				class:premium={isPremium}
			>
				{#if isPremium}
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="14"
						height="14"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2.5"
						stroke-linecap="round"
						stroke-linejoin="round"
						><path
							d="M22 11.08V12a10 10 0 1 1-5.93-9.14"
						/><polyline points="22 4 12 14.01 9 11.01" /></svg
					>
					Plus
				{:else}
					Gratiskonto
				{/if}
			</span>
		</div>
		<div class="info-item">
			<span class="info-label">E-postadress</span>
			<span class="info-value">{email}</span>
		</div>
		{#if firstName && lastName}
			<div class="info-item">
				<span class="info-label">Namn</span>
				<span class="info-value">{firstName} {lastName}</span>
			</div>
		{:else if firstName}
			<div class="info-item">
				<span class="info-label">Namn</span>
				<span class="info-value">{firstName}</span>
			</div>
		{/if}

		<div class="info-item organization-field">
			<span class="info-label">Bostadsrättsförenings Org.nr</span>
			{#if organizationNumber && !organizationNumberInput}
				<div class="organization-display">
					<span class="info-value">{organizationNumber}</span>
					<button
						class="edit-link"
						on:click={onEditOrgNumber}
						disabled={actionLoading}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="13"
							height="13"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
							><path
								d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
							></path><path
								d="m18.5 2.5-8 8v4h4l8-8a2 2 0 0 0 0-4z"
							></path></svg
						>
						Ändra
					</button>
				</div>
			{:else}
				<div class="organization-input">
					<input
						type="text"
						bind:value={organizationNumberInput}
						placeholder="XXXXXX-XXXX"
						class="org-input"
						class:error={organizationNumberError}
						disabled={actionLoading}
						maxlength="11"
						on:input={onValidateInput}
						on:blur={onFormatBlur}
					/>
					{#if organizationNumberError}
						<p class="input-error-message">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="14"
								height="14"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								aria-hidden="true"
								><path
									d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
								/><line x1="12" y1="9" x2="12" y2="13" /><line
									x1="12"
									y1="17"
									x2="12.01"
									y2="17"
								/></svg
							>
							{organizationNumberError}
						</p>
					{/if}
					<div class="button-group">
						<button
							class="primary-button"
							on:click={onUpdateOrgNumber}
							disabled={actionLoading ||
								!organizationNumberInput ||
								organizationNumberError}
						>
							{actionLoading ? "Sparar..." : "Spara"}
						</button>
						{#if organizationNumber}
							<button
								class="secondary-button"
								on:click={onCancelOrgEdit}
								disabled={actionLoading}
							>
								Avbryt
							</button>
						{/if}
						{#if !actionLoading && organizationNumberInput && !organizationNumberError}
							<p class="field-note">
								<strong>Viktigt:</strong> Genom att ange ett organisationsnummer
								bekräftar du på heder och samvete att du är medlem
								i den angivna bostadsrättsföreningen.
							</p>
						{/if}
					</div>
				</div>
			{/if}
			<div class="org-field-info">
				<p class="field-note">
					Läs mer om detta i våra <Link to="/legal#org-section"
						>allmänna villkor</Link
					>.
				</p>
			</div>
		</div>
	</div>

	{#if !isPremium}
		<div class="inactive-subscription">
			<div class="info-item">
				<span class="info-label">Abonnemang</span>
				<span class="info-value status-{subscriptionStatus}">
					{#if subscriptionStatus === "inactive"}Inget abonnemang
					{:else if subscriptionStatus === "canceled"}Avslutat
					{:else if subscriptionStatus === "incomplete"}Ofullständig
					{:else if subscriptionStatus === "incomplete_expired"}Ofullständig
						(utgånget)
					{:else if subscriptionStatus === "past_due"}Förfallen
					{:else if subscriptionStatus === "unpaid"}Obetald
					{:else}Okänd{/if}
				</span>
			</div>
			<button
				class="sync-link"
				style="margin-top: 20px;"
				on:click={onSyncSubscription}
				disabled={actionLoading || isSyncOnCooldown}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="14"
					height="14"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					><polyline points="23 4 23 10 17 10"></polyline><polyline
						points="1 20 1 14 7 14"
					></polyline><path
						d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
					></path></svg
				>
				{actionLoading
					? "Laddar..."
					: isSyncOnCooldown
						? "Vänta..."
						: "Uppdatera status"}
			</button>
		</div>
	{/if}
</div>
